import styled from 'styled-components';
import { color, container, fontSize, fontWeight, screen, spacing } from 'theme';

export const StyledFooter = styled.footer`
  margin-top: ${spacing('xl4')};
  background-color: var(--out-of-office-blue);
  clip-path: polygon(0 5rem, 100% 0, 100% 100%, 0% 100%);
  padding-top: ${spacing('xl5')};
  padding-bottom: ${spacing('xl4')};

  @media (min-width: ${screen('lg')}) {
    clip-path: polygon(0 10rem, 100% 0, 100% 100%, 0% 100%);
    padding-top: ${spacing('xl7')};
  }
`;

export const StyledFooterContainer = styled.div`
  max-width: ${container('xlMax')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  margin: auto;
  display: flex;
  flex-direction: column;
`;

export const StyledFooterMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StyledFooterLogo = styled.div`
  flex-shrink: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('sm')};

  img {
    display: block;
    width: auto;
    height: ${spacing('xl2')};
  }
`;

export const StyledFooterCopyright = styled.small`
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('medium')};
  color: ${color('white')};
`;

export const StyledFooterNavItem = styled.a`
  font-weight: ${fontWeight('medium')};
  font-size: ${fontSize('sm')};
  line-height: 1;
  color: ${color('link_inverse')};

  &:hover {
    color: ${color('link_inverse_hover')};
  }

  &:active,
  &.active {
    color: ${color('link_inverse_active')};
  }
`;

export const StyledFooterNavCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
  margin-top: ${spacing('xl')};
  padding-top: ${spacing('xl')};
  border-top: 1px solid ${color('white')};
`;

export const StyledFooterSecondary = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    justify-content: space-between;
  }

  ul {
    display: flex;
    gap: ${spacing('md')};
  }

  ${StyledFooterNavItem} {
    font-size: ${fontSize('xs')};
  }
`;

export const StyledFooterSocial = styled.a`
  color: ${color('text_white')};

  &:hover {
    color: ${color('link_inverse_hover')};
  }

  &:active,
  &.active {
    color: ${color('link_inverse_active')};
  }

  svg {
    width: ${spacing('mdlg')} !important;
    height: ${spacing('mdlg')};
  }
`;
